import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { getReportTimeStamp } from "../../Utils/Utils";

export async function downloadPdf(dataSet) {
  const { name, columns, rows, widths, header } = dataSet
  const nameWithTimestamp = getReportTimeStamp(name)
    try {
        const doc = jsPDF("p", "pt", "A4");
        doc.autoTable(columns, rows, {
          // beforePageContent: header,
          theme: "grid",
          margin: { top: 60 },
          pageBreak: "auto",
          styles: { overflow: "linebreak", fontSize: 7 },
          columnStyles: widths,
          didDrawPage: function (data) {
            // Header
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.text(header, data.settings.margin.left, 22);
          },
        });
        doc.save(nameWithTimestamp);
    } catch (error) {
        throw error
    }
 
}
